import React, { useState, useEffect } from 'react';
import { Button, Pagination, Modal, Select, Checkbox, DatePicker, Input, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './YourTownloopOrdersListCar.module.scss';
import { useAppSelector } from '@/store/hooks';
import Membership from '@/components/Membership';
import { saveToCart } from '@/api/cart';
import dayjs from 'dayjs';
import { CheckOutlined } from '@ant-design/icons';
import CarpoolProgressDetail from '../CarpoolProgressDetail';
import { useTranslation } from 'react-i18next';
import {
  saveRideOrder,
  saveDeliveryOrder,
  getCarpoolById,
  getDeliveryById,
  getCarpoolOrderBiddingList,
  getDeliveryOrderBiddingList,
  deleteCarpoolOrder,
  deleteDeliveryOrder,
  cancelCarpoolOrder,
  cancelDeliveryOrder,
  driverResponsibleCancelAndPaySuccess,
  deleteDriverCarpoolOrder,
  deleteDriverDeliveryOrder
} from '@/api/car';
import icon from '@/assets/images/组 3074@2x.png';
import { OrderItem } from '@/pages/YourTownloop/Subroute/PostOrders/order';
import { carpoolOrderStatusOptionsMapper } from '@/utils/constants';

const { TextArea } = Input;
const { Option } = Select;




// 竞价数据类型
interface BiddingData {
  carpool_order_bidding_id?: number;
  carpool_order_id?: string;
  driver_user_id?: string;
  bidding_price?: number;
  is_delete?: boolean;
  bidding_status?: number;
  created_time?: string;
  update_time?: string;
  pricing_method?: number;

}




interface YourTownloopOrdersListProps {
  orders: OrderItem[];
  getId?: (id: string, action: string) => void;
  type?: 'ride' | 'delivery';
  isPoster?: boolean;//true是订单发布者 false是司机接单人
}

const YourTownloopOrdersList: React.FC<YourTownloopOrdersListProps> = ({ orders, getId, type, isPoster = true }) => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  // 国际化
    const { t } = useTranslation();
  // 订单状态映射 - 使用枚举
  const getOrderStatusText = (status: number): string => {
    const orderStatusOptions = carpoolOrderStatusOptionsMapper();
    const statusOption = orderStatusOptions.find(option => option.value === status);
    return t('YourTownloopOrdersList.' + statusOption?.label) || 'Unknown Status';
  };

  //美国州列表
  const StateList = useAppSelector((state) => state.common.StateList);


  // 竞价相关状态
  const [biddingModalVisible, setBiddingModalVisible] = useState(false);
  const [biddingData, setBiddingData] = useState<BiddingData[]>([]);
  const [biddingPagination, setBiddingPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });




  // 发布顺风车帖子弹窗
  const [showPublishModal, setShowPublishModal] = useState(false);


  // 发布顺风车帖子表单
  const [publishForm, setPublishForm] = useState<OrderItem>({
    carpool_order_id: undefined,
    departure_date: '',
    acceptable_advance_delay: 0,
    stopovers: 0,
    starting_point_state: '',
    starting_point_city: '',
    starting_point_address: '',
    destination_point_state: '',
    destination_point_city: '',
    destination_point_address: '',
    seats_needed: 0,
    has_luggage: true,
    final_price: 0,
    budget_price: 0,
    service_requirements: '',
    notes: '',
    starting_point_latitude: 0,
    starting_point_longitude: 0,
    destination_point_latitude: 0,
    destination_point_longitude: 0,
    distance: 0,
    bid_record_count: 0,
    order_status: 0,
    pickup_time: '',
    expected_delivery_time: '',
    item_description: '',
    quantity: 0,
    package_size: '',
    package_weight: '',
    carpool_order_status: 0,
    delivery_order_id: undefined,
    partner_user_id: '',
  });

  // 修改表单内容
  const handlePublishChange = (key: string, value: any) => {
    setPublishForm((prev: OrderItem) => ({ ...prev, [key]: value }));
  };


  //取消发布
  const cancelSubmit = () => {
    console.log('save draft:', publishForm);
    setShowPublishModal(false);
  };


  // 发布人编辑发布拼车送人订单
  const submitPostRide = async () => {
    // 这里可接入后端发布接口
    if (!publishForm.departure_date) {
      message.error('Departure Date is required');
      return;
    }
    if (dayjs(publishForm.departure_date).isBefore(dayjs())) {
      message.error('Departure Date must be in the future');
      return;
    }

    if (!publishForm.acceptable_advance_delay) {
      message.error('Acceptable advance/delay is required');
      return;
    }

    if (!publishForm.stopovers && publishForm.stopovers !== 0) {
      message.error('Stopovers is required');
      return;
    }

    if (!publishForm.starting_point_state) {
      message.error('From State is required');
      return;
    }

    if (!publishForm.starting_point_city) {
      message.error('From City is required');
      return;
    }

    if (!publishForm.starting_point_address) {
      message.error('From Address is required');
      return;
    }

    if (!publishForm.destination_point_state) {
      message.error('To State is required');
      return;
    }

    if (!publishForm.destination_point_city) {
      message.error('To City is required');
      return;
    }

    if (!publishForm.destination_point_address) {
      message.error('To Address is required');
      return;
    }

    if (!publishForm.seats_needed) {
      message.error('Seats Needed is required');
      return;
    }


    if (!publishForm.has_luggage && publishForm.has_luggage !== false) {
      message.error('Luggage is required');
      return;
    }

    if (!publishForm.budget_price) {
      message.error('Budget is required');
      return;
    }

    const publishFormCopy = {
      ...publishForm,
      departure_date: dayjs(publishForm.departure_date).format('YYYY-MM-DD HH:mm:ss'),  //YYYY-MM-DD HH:mm:ss    MM-DD-YYYY HH:mm:ss
    };

    console.log('post ride form:', publishFormCopy);

    // 获取经纬度
    const key = process.env.REACT_APP_GOOGLE_MAP_KEY as string;

    // 起点
    const startingAddr = publishFormCopy.starting_point_address + ',' + publishFormCopy.starting_point_city + ',' + publishFormCopy.starting_point_state;

    // 终点
    const endAddr = publishFormCopy.destination_point_address + ',' + publishFormCopy.destination_point_city + ',' + publishFormCopy.destination_point_state;

    console.log(startingAddr, 'startingAddr');
    console.log(key, 'key');
    let startingLatitude: number | null = null;
    let startingLongitude: number | null = null;

    let endLatitude: number | null = null;
    let endLongitude: number | null = null;

    try {
      if (!startingAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(startingAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        startingLatitude = loc.lat;
        startingLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    try {
      if (!endAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(endAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        endLatitude = loc.lat;
        endLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    // 调用发布接口
    publishFormCopy.starting_point_latitude = Number(startingLatitude?.toFixed(5));
    publishFormCopy.starting_point_longitude = Number(startingLongitude?.toFixed(5));

    publishFormCopy.destination_point_latitude = Number(endLatitude?.toFixed(5));
    publishFormCopy.destination_point_longitude = Number(endLongitude?.toFixed(5));

    saveRideOrder(publishFormCopy).then((res: any) => {
      if (res.code === 200) {
        message.success('Post ride successfully');
        setShowPublishModal(false);

        // 调用父组件的方法，用于刷新列表
        getId && getId(publishFormCopy.carpool_order_id as string, 'refresh');


        setPublishForm({
          carpool_order_id: undefined,
          departure_date: '',
          acceptable_advance_delay: 0,
          stopovers: 0,
          starting_point_state: '',
          starting_point_city: '',
          starting_point_address: '',
          destination_point_state: '',
          destination_point_city: '',
          destination_point_address: '',
          seats_needed: 0,
          has_luggage: true,
          final_price: 0,
          budget_price: 0,
          service_requirements: '',
          notes: '',
          starting_point_latitude: 0,
          starting_point_longitude: 0,
          destination_point_latitude: 0,
          destination_point_longitude: 0,
          distance: 0,
          bid_record_count: 0,
          order_status: 0,
          pickup_time: '',
          expected_delivery_time: '',
          item_description: '',
          quantity: 0,
          package_size: '',
          package_weight: '',
          carpool_order_status: 0,
          delivery_order_id: undefined,
          partner_user_id: '',
        });

      } else {
        message.error('Post ride failed');
      }
    });

  };



  // 发布人编辑发布拼车送货订单
  const submitPostDelivery = async () => {
    // 这里可接入后端发布接口
    // 验证表单
    if (!publishForm.pickup_time) {
      message.error('Pickup Time is required');
      return;
    }
    if (dayjs(publishForm.pickup_time).isBefore(dayjs())) {
      message.error('Pickup Time must be in the future');
      return;
    }

    if (!publishForm.expected_delivery_time) {
      message.error('Expected Delivery Time is required');
      return;
    }
    if (dayjs(publishForm.expected_delivery_time).isBefore(dayjs())) {
      message.error('Expected Delivery Time must be in the future');
      return;
    }

    if (!publishForm.starting_point_state) {
      message.error('Pickup State is required');
      return;
    }

    if (!publishForm.starting_point_city) {
      message.error('Pickup City is required');
      return;
    }

    if (!publishForm.starting_point_address) {
      message.error('Pickup Address is required');
      return;
    }

    if (!publishForm.destination_point_state) {
      message.error('Drop-Off State is required');
      return;
    }

    if (!publishForm.destination_point_city) {
      message.error('Drop-Off City is required');
      return;
    }

    if (!publishForm.destination_point_address) {
      message.error('Drop-Off Address is required');
      return;
    }

    if (!publishForm.item_description) {
      message.error('Item Description is required');
      return;
    }

    if (!publishForm.quantity) {
      message.error('Quantity is required');
      return;
    }

    if (!publishForm.package_size) {
      message.error('Package Size is required');
      return;
    }

    if (!publishForm.package_weight) {
      message.error('Package Weight is required');
      return;
    }


    if (!publishForm.budget_price) {
      message.error('Budget is required');
      return;
    }

    const publishFormCopy = {
      ...publishForm,
      pickup_time: dayjs(publishForm.pickup_time).format('YYYY-MM-DD HH:mm:ss'),
      expected_delivery_time: dayjs(publishForm.expected_delivery_time).format('YYYY-MM-DD HH:mm:ss'),
    };

    console.log('post ride form:', publishFormCopy);

    // 获取经纬度
    const key = process.env.REACT_APP_GOOGLE_MAP_KEY as string;

    // 起点
    const startingAddr = publishFormCopy.starting_point_address + ',' + publishFormCopy.starting_point_city + ',' + publishFormCopy.starting_point_state;

    // 终点
    const endAddr = publishFormCopy.destination_point_address + ',' + publishFormCopy.destination_point_city + ',' + publishFormCopy.destination_point_state;

    console.log(startingAddr, 'startingAddr');
    console.log(key, 'key');
    let startingLatitude: number | null = null;
    let startingLongitude: number | null = null;

    let endLatitude: number | null = null;
    let endLongitude: number | null = null;

    try {
      if (!startingAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(startingAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        startingLatitude = loc.lat;
        startingLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    try {
      if (!endAddr || !key) {
        console.log('地址或地图密钥缺失');
        return;
      }
      const geoRes = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(endAddr)}&key=${key}`);
      const geoJson = await geoRes.json();
      if (geoJson.status === 'OK' && geoJson.results && geoJson.results[0]) {
        const loc = geoJson.results[0].geometry.location;
        endLatitude = loc.lat;
        endLongitude = loc.lng;
      } else {
        console.log('地址解析失败，请检查地址');
        return;
      }
    } catch (e) {
      console.error('地址解析异常:', e);
      return;
    }

    // 调用发布接口
    publishFormCopy.starting_point_latitude = Number(startingLatitude?.toFixed(5));
    publishFormCopy.starting_point_longitude = Number(startingLongitude?.toFixed(5));

    publishFormCopy.destination_point_latitude = Number(endLatitude?.toFixed(5));
    publishFormCopy.destination_point_longitude = Number(endLongitude?.toFixed(5));

    saveDeliveryOrder(publishFormCopy).then((res: any) => {
      if (res.code === 200) {
        message.success('Post ride successfully');
        setShowPublishModal(false);

        // 调用父组件的删除方法，用于刷新列表
        getId && getId(publishFormCopy.carpool_order_id as string, 'refresh');


        setPublishForm({
          carpool_order_id: undefined,
          departure_date: '',
          acceptable_advance_delay: 0,
          stopovers: 0,
          starting_point_state: '',
          starting_point_city: '',
          starting_point_address: '',
          destination_point_state: '',
          destination_point_city: '',
          destination_point_address: '',
          seats_needed: 0,
          has_luggage: true,
          final_price: 0,
          budget_price: 0,
          service_requirements: '',
          notes: '',
          starting_point_latitude: 0,
          starting_point_longitude: 0,
          destination_point_latitude: 0,
          destination_point_longitude: 0,
          distance: 0,
          bid_record_count: 0,
          order_status: 0,
          pickup_time: '',
          expected_delivery_time: '',
          item_description: '',
          quantity: 0,
          package_size: '',
          package_weight: '',
          carpool_order_status: 0,
          delivery_order_id: undefined,
          partner_user_id: '',
        });

      } else {
        message.error('Post ride failed');
      }
    });
  };


  // 订单详情弹出框状态
  const [orderDetailsModalVisible, setOrderDetailsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any | null>(null);

  // 弹出框展开产品详情
  const OrderDetails = (order: any) => {
    // 传递订单ID用于获取订单详情 - 使用btoa编码
    setSelectedOrder(order);
    setOrderDetailsModalVisible(true);
  };

  // 发布人删除拼车订单确认
  const handleDeleteOrder = (order: OrderItem) => {
    Modal.confirm({
      title: t('YourTownloopOrdersList.ConfirmDeleteOrder'),
      content: `Are you sure you want to delete order ${order.carpool_order_id}? This action cannot be undone.`,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          let api = deleteCarpoolOrder;
          if (type === 'delivery') {
            api = deleteDeliveryOrder;
          }

          const res = await api((order.carpool_order_id || order.delivery_order_id) as string);
          if (res.code === 200) {
            message.success('Order deleted successfully');
            // 调用父组件的删除方法，用于刷新列表
            getId && getId((order.carpool_order_id || order.delivery_order_id) as string, 'delete');
          } else {
            message.error(res.message || 'Delete failed');
          }
        } catch (error) {
          console.error('Delete order failed:', error);
          message.error('Delete failed, please try again');
        }
      },
    });
  };

  // 发布人取消拼车订单确认
  const handleOrderCancelled = (order: OrderItem) => {
    Modal.confirm({
      title: 'Confirm Cancel Order',
      content: `Are you sure you want to cancel order ${order.carpool_order_id}? This action cannot be undone.`,
      okText: 'Cancel Order',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          let api = cancelCarpoolOrder;
          if (type === 'delivery') {
            api = cancelDeliveryOrder;
          }

          const res = await api((order.carpool_order_id || order.delivery_order_id) as string);
          if (res.code === 200) {
            message.success('Order cancelled successfully');
            // 用于刷新列表
            getId && getId((order.carpool_order_id || order.delivery_order_id) as string, 'delete');
          } else {
            message.error(res.message || 'Cancel order failed');
          }
        } catch (error) {
          console.error('Cancel order failed:', error);
          message.error('Cancel order failed, please try again');
        }
      }
    });
  };

  //发布人竞价弹窗
  const handleOrderBidding = (order: OrderItem) => {

    let api = getCarpoolOrderBiddingList;

    if (type === 'delivery') {
      api = getDeliveryOrderBiddingList;
    }

    console.log('order', order);
    api((order.carpool_order_id || order.delivery_order_id) as string).then((res) => {
      console.log('res', res);
      if (res.code === 200) {
        setBiddingData(res.data);
        setBiddingPagination({
          current: 1,
          pageSize: 10,
          total: res.total
        });
        setBiddingModalVisible(true);
      }
    }).catch((err) => {
      console.log('err', err);
      message.error('Failed to get bidding data');
    });




  }

  // 添加会员弹窗状态控制
  const [membershipModalOpen, setMembershipModalOpen] = useState<boolean>(false);

  // 支付成功弹窗
  const [showPaySuccess, setShowPaySuccess] = useState(false);
  const closePaySuccess = () => setShowPaySuccess(false);
  const [selectedBiddingItem, setSelectedBiddingItem] = useState<BiddingData | null>(null);

  // 处理会员购买弹窗的回调函数
  const handleMembershipCancel = () => {
    setMembershipModalOpen(false);
  };

  //支付会员确认
  const handleMembershipConfirm = (values: any) => {
    console.log('Membership purchase confirmed:', values);
    debugger
    // 检查是否是支付成功
    if (values.paymentSuccess) {

      message.success('The fare payment has been successful');
      //关闭会员付款弹窗
      setMembershipModalOpen(false);

      //关闭竞价弹窗
      setBiddingModalVisible(false);

      // ✅ Webhook 会自动处理支付成功逻辑，前端只需刷新列表
      // 调用父组件的方法，用于刷新列表
      getId && getId('', 'refresh');




    } else {
      setMembershipModalOpen(false);
      // // 如果没有支付成功信息，按原来的逻辑处理

    }
  };



  // 处理支付按钮点击
  const handlePayClick = (biddingItem: BiddingData) => {
    console.log('biddingItem', biddingItem);

    setSelectedBiddingItem(biddingItem);

    // 这里可以添加实际的支付逻辑
    setMembershipModalOpen(true);
  };

  // 竞价分页变化
  const handleBiddingPaginationChange = (page: number, pageSize: number) => {
    setBiddingPagination({
      ...biddingPagination,
      current: page,
      pageSize
    });
  };

  //发布人编辑拼车订单弹窗
  const handleOrderEdit = (order: OrderItem) => {
    console.log('order', order);

    let api = getCarpoolById;

    let params: any = {
      carpool_order_id: order.carpool_order_id
    };

    if (type === 'delivery') {
      api = getDeliveryById;
      params = order.delivery_order_id;
    }

    // 根据ID获取订单详情
    api(params).then((res) => {
      console.log('res', res);

      if (res.code === 200) {

        const orderDetails = res.data;

        setPublishForm({
          partner_user_id: orderDetails?.partner_user_id,
          carpool_order_id: orderDetails?.carpool_order_id,
          departure_date: orderDetails?.departure_date ? dayjs(orderDetails.departure_date) : '',
          acceptable_advance_delay: orderDetails?.acceptable_advance_delay,
          stopovers: orderDetails?.stopovers,
          starting_point_state: orderDetails?.starting_point_state,
          starting_point_city: orderDetails?.starting_point_city,
          starting_point_address: orderDetails?.starting_point_address,
          destination_point_state: orderDetails?.destination_point_state,
          destination_point_city: orderDetails?.destination_point_city,
          destination_point_address: orderDetails?.destination_point_address,
          seats_needed: orderDetails?.seats_needed,
          has_luggage: orderDetails?.has_luggage,
          final_price: orderDetails?.final_price,
          budget_price: orderDetails?.budget_price,
          service_requirements: orderDetails?.service_requirements,
          notes: orderDetails?.notes,
          starting_point_latitude: orderDetails?.starting_point_latitude,
          starting_point_longitude: orderDetails?.starting_point_longitude,
          destination_point_latitude: orderDetails?.destination_point_latitude,
          destination_point_longitude: orderDetails?.destination_point_longitude,
          distance: orderDetails?.distance,
          bid_record_count: orderDetails?.bid_record_count,
          order_status: orderDetails?.order_status,
          pickup_time: orderDetails?.pickup_time ? dayjs(orderDetails.pickup_time) : '',
          expected_delivery_time: orderDetails?.expected_delivery_time ? dayjs(orderDetails.expected_delivery_time) : '',
          item_description: orderDetails?.item_description,
          quantity: orderDetails?.quantity,
          package_size: orderDetails?.package_size,
          package_weight: orderDetails?.package_weight,
          carpool_order_status: orderDetails?.carpool_order_status,
          delivery_order_id: orderDetails?.delivery_order_id,
        });


        setShowPublishModal(true);

      } else {
        message.error(res.message || 'Failed to get order details');

      }


    })

  }

  //发布人拼车订单进度弹窗状态控制
  const [showProgressModal, setShowProgressModal] = useState(false);

  //发布人拼车订单进度弹窗
  const handleOrderProgress = (order: OrderItem) => {
    console.log('order', order);

    let api = getCarpoolById;

    let params: any = {
      carpool_order_id: order.carpool_order_id
    };

    if (type === 'delivery') {
      api = getDeliveryById;
      params = order.delivery_order_id;
    }

    // 根据ID获取订单详情
    api(params).then((res) => {
      console.log('res', res);

      if (res.code === 200) {

        const orderDetails = res.data;

        setPublishForm({
          partner_user_id: orderDetails?.partner_user_id,
          carpool_order_id: orderDetails?.carpool_order_id,
          departure_date: orderDetails?.departure_date ? dayjs(orderDetails.departure_date) : '',
          acceptable_advance_delay: orderDetails?.acceptable_advance_delay,
          stopovers: orderDetails?.stopovers,
          starting_point_state: orderDetails?.starting_point_state,
          starting_point_city: orderDetails?.starting_point_city,
          starting_point_address: orderDetails?.starting_point_address,
          destination_point_state: orderDetails?.destination_point_state,
          destination_point_city: orderDetails?.destination_point_city,
          destination_point_address: orderDetails?.destination_point_address,
          seats_needed: orderDetails?.seats_needed,
          has_luggage: orderDetails?.has_luggage,
          final_price: orderDetails?.bidding_price,
          budget_price: orderDetails?.budget_price,
          service_requirements: orderDetails?.service_requirements,
          notes: orderDetails?.notes,
          starting_point_latitude: orderDetails?.starting_point_latitude,
          starting_point_longitude: orderDetails?.starting_point_longitude,
          destination_point_latitude: orderDetails?.destination_point_latitude,
          destination_point_longitude: orderDetails?.destination_point_longitude,
          distance: orderDetails?.distance,
          bid_record_count: orderDetails?.bid_record_count,
          order_status: orderDetails?.order_status,
          pickup_time: orderDetails?.pickup_time ? dayjs(orderDetails.pickup_time) : '',
          expected_delivery_time: orderDetails?.expected_delivery_time ? dayjs(orderDetails.expected_delivery_time) : '',
          item_description: orderDetails?.item_description,
          quantity: orderDetails?.quantity,
          package_size: orderDetails?.package_size,
          package_weight: orderDetails?.package_weight,
          carpool_order_status: orderDetails?.carpool_order_status,
          delivery_order_id: orderDetails?.delivery_order_id,
        });


        setShowProgressModal(true);

      } else {
        message.error(res.message || 'Failed to get order details');

      }


    })

  }


  //关闭发布人拼车订单进度弹窗
  const CarpoolProgressDetailClose = (id: string, action: string) => {
    //刷新当前页面
    getId && getId(id, action);
    //关闭当前弹窗
    setShowProgressModal(false);
  }




  //司机接单人拼车订单导航弹窗
  const handleOrderNavigation = (order: OrderItem) => {
    console.log('order', order);

    let api = getCarpoolById;

    let params: any = {
      carpool_order_id: order.carpool_order_id
    };

    if (type === 'delivery') {
      api = getDeliveryById;
      params = order.delivery_order_id;
    }

    // 根据ID获取订单详情
    api(params).then((res) => {
      console.log('res', res);

      if (res.code === 200) {

        const orderDetails = res.data;

        setPublishForm({
          partner_user_id: orderDetails?.partner_user_id,
          carpool_order_id: orderDetails?.carpool_order_id,
          departure_date: orderDetails?.departure_date ? dayjs(orderDetails.departure_date) : '',
          acceptable_advance_delay: orderDetails?.acceptable_advance_delay,
          stopovers: orderDetails?.stopovers,
          starting_point_state: orderDetails?.starting_point_state,
          starting_point_city: orderDetails?.starting_point_city,
          starting_point_address: orderDetails?.starting_point_address,
          destination_point_state: orderDetails?.destination_point_state,
          destination_point_city: orderDetails?.destination_point_city,
          destination_point_address: orderDetails?.destination_point_address,
          seats_needed: orderDetails?.seats_needed,
          has_luggage: orderDetails?.has_luggage,
          final_price: orderDetails?.final_price,
          budget_price: orderDetails?.budget_price,
          service_requirements: orderDetails?.service_requirements,
          notes: orderDetails?.notes,
          starting_point_latitude: orderDetails?.starting_point_latitude,
          starting_point_longitude: orderDetails?.starting_point_longitude,
          destination_point_latitude: orderDetails?.destination_point_latitude,
          destination_point_longitude: orderDetails?.destination_point_longitude,
          distance: orderDetails?.distance,
          bid_record_count: orderDetails?.bid_record_count,
          order_status: orderDetails?.order_status,
          pickup_time: orderDetails?.pickup_time ? dayjs(orderDetails.pickup_time) : '',
          expected_delivery_time: orderDetails?.expected_delivery_time ? dayjs(orderDetails.expected_delivery_time) : '',
          item_description: orderDetails?.item_description,
          quantity: orderDetails?.quantity,
          package_size: orderDetails?.package_size,
          package_weight: orderDetails?.package_weight,
          carpool_order_status: orderDetails?.carpool_order_status,
          delivery_order_id: orderDetails?.delivery_order_id,
        });


        setShowProgressModal(true);

      } else {
        message.error(res.message || 'Failed to get order details');

      }


    })

  }

  //司机接单人拼车订单支付取消
  const [driverCancelsPaymentModalOpen, setDriverCancelsPaymentModalOpen] = useState<boolean>(false);
  const [selectedDriverCancelsPaymentItem, setSelectedDriverCancelsPaymentItem] = useState<OrderItem | null>(null);

  // 关闭司机有偿取消弹窗
  const handleDriverCancelsPaymentCancel = () => {
    setDriverCancelsPaymentModalOpen(false);
  };

  //司机有偿取消确认
  const handleDriverCancelsPaymentConfirm = (values: any) => {
    console.log('司机有责取消订单成功:', values);
    debugger
    // 检查是否是支付成功
    if (values.paymentSuccess) {

      message.success('Order Cancellation Successful');
      //关闭会员付款弹窗
      setDriverCancelsPaymentModalOpen(false);


      //打开支付成功弹窗
      setShowPaySuccess(true);

      

      //司机有责取消拼车订单并付款成功
      driverResponsibleCancelAndPaySuccess({
        responsible_order_id: values.orderId,
        order_id: values.carpoolOrderId,
        payment_intent_id: values.payment_intent_id,
      }).then((res) => {
        console.log('res', res);
        //刷新当前页面
        getId && getId("", 'refresh');
      });



    } else {
      setDriverCancelsPaymentModalOpen(false);
      // // 如果没有支付成功信息，按原来的逻辑处理

    }
  };

  //司机接单人拼车订单有偿取消
  const handleOrderPaidCancelled = (order: OrderItem) => {
    console.log('order', order);

    setSelectedDriverCancelsPaymentItem(order);

    // 这里可以添加实际的支付逻辑
    setDriverCancelsPaymentModalOpen(true);
  }

  //司机接单人拼车订单删除
  const handleOrderPaidDeleted = (order: OrderItem) => {
    Modal.confirm({
      title: t('YourTownloopOrdersList.ConfirmDeleteOrder'),
      content: `${t('YourTownloopOrdersList.WantDeleteOrder')} ${t('YourTownloopOrdersList.Thisactioncannotbeundone')} ${order.carpool_order_id} `,
      okText: t('YourTownloopOrdersList.Delete'),
      okType: 'danger',
      cancelText: t('YourTownloopOrdersList.Cancel'),
      onOk: async () => {
        try {
          let api = deleteDriverCarpoolOrder;
          if (type === 'delivery') {
            api = deleteDriverDeliveryOrder;
          }

          const res = await api((order.carpool_order_id || order.delivery_order_id) as string);
          if (res.code === 200) {
            message.success('Order deleted successfully');
            // 调用父组件的删除方法，用于刷新列表
            getId && getId((order.carpool_order_id || order.delivery_order_id) as string, 'delete');
          } else {
            message.error(res.message || 'Delete failed');
          }
        } catch (error) {
          console.error('Delete order failed:', error);
          message.error('Delete failed, please try again');
        }
      },
    });
  }

  return (
    <div className={styles['orders-list-wrapper']}>
      {/* 表头 */}
      <div className={styles['orders-list-header']}>
        <div className={styles['header-info']}>{t('YourTownloopOrderListCar.OrderInformation')}</div>
        <div className={styles['header-amount']}>{t('YourTownloopOrderListCar.BudgetAmount')}</div>
        <div className={styles['header-paid']}>{t('YourTownloopOrderListCar.FinalPrice')}</div>
        <div className={styles['header-handle']}>{t('YourTownloopOrderListCar.Operation')}</div>
      </div>
      {orders.map(order => (
        <div className={styles['order-block']} key={order.carpool_order_id || order.delivery_order_id}>
          {/* 订单头部 */}
          <div className={styles['order-header']}>
            <div className={styles['order-header-left']}>
              <span className={styles['order-date']}>{order.created_time}</span>
              <span className={styles['order-number']}>{t('YourTownloopOrdersList.OrderNumber')}：{order.carpool_order_id || order.delivery_order_id}</span>
              <span
                className={styles['order-details']}
                onClick={() => OrderDetails(order)}
              >{t('YourTownloopOrdersList.OrderDetails')}</span>
            </div>
            <div className={styles['order-header-right']}>
              <span className={styles['order-status']}>{getOrderStatusText((order.carpool_order_status || order.order_status) as number)}</span>
            </div>
          </div>
          {/* 商品信息区块 */}
          <div className={styles['order-body']}>
            <div className={styles['order-product-info']}>
              <img className={styles['product-img']} onClick={() => navigate(`/ProductDetail/${1}`)} src={icon} />
              <div className={styles['product-detail']}>

                <div className={styles['product-specs']}>
                  {type === 'ride' ? (
                    <>
                      <div className={styles['spec-item']}>
                        <span className={styles['spec-label']}>{t('YourTownloopOrdersListCar.AppointmentTime')}:</span>
                        <span className={styles['spec-value']}>
                          {typeof order.departure_date === 'string' ? order.departure_date : dayjs(order.departure_date).format('YYYY-MM-DD HH:mm:ss')}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className={styles['spec-item']}>
                      <span className={styles['spec-label']}>Pickup Time:</span>
                      <span className={styles['spec-value']}>
                        {typeof order.pickup_time === 'string' ? order.pickup_time : dayjs(order.pickup_time).format('YYYY-MM-DD HH:mm:ss')}
                      </span>
                    </div>
                  )}

                  <div className={styles['spec-item']}>
                    <span className={styles['spec-label']}>{t('YourTownloopOrdersListCar.StartingPoint')}</span>
                    <span className={styles['spec-value']}>{order.starting_point_address + ',' + order.starting_point_city + ',' + order.starting_point_state}</span>
                  </div>
                  <div className={styles['spec-item']}>
                    <span className={styles['spec-label']}>{t('YourTownloopOrdersListCar.Destination')}</span>
                    <span className={styles['spec-value']}>{order.destination_point_address + ',' + order.destination_point_city + ',' + order.destination_point_state}</span>
                  </div>
                </div>

              </div>
            </div>
            <div className={styles['order-price-info']}>
              <div className={styles['price-label']}>${order.budget_price}</div>
            </div>
            <div className={styles['order-paid-info']}>
              <div className={styles['paid-label-box']}>
                <div className={styles['paid-amount']}>${order.final_price}</div>
              </div>
            </div>
            <div className={styles['order-actions']}>

              {/* 待竞价 */}
              {((order.carpool_order_status || order.order_status) === 1) && (
                <>
                  <button
                    className={styles['bidding-btn']}
                    onClick={() => handleOrderBidding(order)}
                  >
                    {t('YourTownloopOrdersListCar.Bidding')}
                  </button>
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderEdit(order)}
                  >
                    {t('YourTownloopOrdersListCar.Edit')}
                  </button>
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderCancelled(order)}
                  >
                    {t('YourTownloopOrdersListCar.Cancel')}
                  </button>
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleDeleteOrder(order)}
                  >
                    {t('YourTownloopOrdersListCar.Delete')}
                  </button>
                </>

              )}

              {/* 发布人拼车订单进行中 */}
              {(isPoster && (order.carpool_order_status || order.order_status) === 3) && (
                <>
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderProgress(order)}
                  >
                    {t('YourTownloopOrdersListCar.Progress')}
                  </button>

                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderCancelled(order)}
                  >
                    {t('YourTownloopOrdersListCar.Cancel')}
                  </button>
                </>
              )}

              {/* 发布人已完成拼车订单 */}
              {(isPoster && (order.carpool_order_status || order.order_status) === 5) && (
                <button
                  className={styles['repeat-cart']}
                  onClick={() => handleDeleteOrder(order)}
                >
                  {t('YourTownloopOrdersListCar.Delete')}
                </button>
              )}



              {/* 司机接单人拼车订单进行中 */}
              {(!isPoster && (order.carpool_order_status || order.order_status) === 3) && (
                <>
                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderNavigation(order)}
                  >
                    {t('YourTownloopOrdersListCar.Navigation')}
                  </button>

                  <button
                    className={styles['repeat-cart']}
                    onClick={() => handleOrderPaidCancelled(order)}
                  >
                    {t('YourTownloopOrdersListCar.Cancel')}
                  </button>
                </>
              )}


              {/* 司机接单人已完成拼车订单 */}
              {(!isPoster && (order.carpool_order_status || order.order_status) === 5) && (
                <button
                  className={styles['repeat-cart']}
                  onClick={() => handleOrderPaidDeleted(order)}
                >
                  {t('YourTownloopOrdersListCar.Delete')}
                </button>
              )}
              
            </div>
          </div>
        </div>
      ))}


      {/* 进度弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            {t('YourTownloopOrdersListCar.OrderProgress')}
          </div>
        }
        open={showProgressModal}
        onCancel={() => setShowProgressModal(false)}
        footer={null}
        width={1200}
        className={styles['progress-modal']}
      >

        <CarpoolProgressDetail orderItem={publishForm} type={type} getId={CarpoolProgressDetailClose} isPoster={isPoster} />

      </Modal>



      {/* 订单详情弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            Order Details
          </div>
        }
        open={orderDetailsModalVisible}
        onCancel={() => setOrderDetailsModalVisible(false)}
        footer={null}
        width={800}
        className={styles['order-details-modal']}
      >
        {selectedOrder && (
          <div className={styles['order-details-content']}>
            {/* 位置和距离信息 */}
            <div className={styles['location-section']}>
              <div className={styles['location-left']}>
                <img
                  className={styles['product-img']}

                  src={icon}

                />
              </div>
              <div className={styles['location-right']}>
                <div className={styles['location-description']}>
                  <span>Starting Point:</span>
                  <span className={styles['location-description-value']}>{selectedOrder.starting_point_address + ',' + selectedOrder.starting_point_city + ',' + selectedOrder.starting_point_state}</span>
                </div>
                <div className={styles['location-description']}>
                  <span>Starting Point:</span>
                  <span className={styles['location-description-value']}>{selectedOrder.destination_point_address + ',' + selectedOrder.destination_point_city + ',' + selectedOrder.destination_point_state}</span>
                </div>
                <div className={styles['distance-item']}>
                  <span className={styles['distanceIcon']} />
                  {selectedOrder.distance || 2.5} Miles From You
                </div>

              </div>
            </div>

            {/* 订单信息 */}
            <div className={styles['order-info-section']}>
              
              
              {type === 'ride' ? (
                <>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Departure:</span>
                    <span className={styles['info-value']}>{selectedOrder.departure_date}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Order Number:</span>
                    <span className={styles['info-value']}>{selectedOrder.carpool_order_id}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Creation Time:</span>
                    <span className={styles['info-value']}>{selectedOrder.created_time}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Seats Needed:</span>
                    <span className={styles['info-value']}>{selectedOrder.seats_needed} People</span>
                  </div>

                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Luggage:</span>
                    <span className={styles['info-value']}>{selectedOrder.has_luggage ? 'Has Luggage' : 'No Luggage'}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Service Requirements:</span>
                    <span className={styles['info-value']}>{selectedOrder.service_requirements}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Order Number:</span>
                    <span className={styles['info-value']}>{selectedOrder.delivery_order_id}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Creation Time:</span>
                    <span className={styles['info-value']}>{selectedOrder.created_time}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Pickup Time:</span>
                    <span className={styles['info-value']}>{selectedOrder.pickup_time}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Expected Delivery Time:</span>
                    <span className={styles['info-value']}>{selectedOrder.expected_delivery_time}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Item Description:</span>
                    <span className={styles['info-value']}>{selectedOrder.item_description}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Quantity:</span>
                    <span className={styles['info-value']}>{selectedOrder.quantity}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Package Size:</span>
                    <span className={styles['info-value']}>{selectedOrder.package_size}</span>
                  </div>
                  <div className={styles['info-row']}>
                    <span className={styles['info-label']}>Package Weight:</span>
                    <span className={styles['info-value']}>{selectedOrder.package_weight}</span>
                  </div>
                </>
              )}


              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Notes:</span>
                <span className={styles['info-value']}>{selectedOrder.notes}</span>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Price:</span>
                <span className={styles['info-value']}>{selectedOrder.fixed_price}</span>
              </div>

            </div>
          </div>
        )}
      </Modal>

      {/* 竞价弹出框 */}
      <Modal
        title={
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#0D323E',
            lineHeight: '34px'
          }}>
            Order Confirmation
          </div>
        }
        open={biddingModalVisible}
        onCancel={() => setBiddingModalVisible(false)}
        footer={null}
        width={1000}
        className={styles['bidding-modal']}
      >
        <div className={styles['bidding-content']}>
          {/* 筛选按钮 */}
          {/* <div className={styles['bidding-filters']}>
            <button className={styles['filter-btn']}>
              Price <span className={styles['arrow']}>↕</span>
            </button>
            <button className={styles['filter-btn']}>
              Distance <span className={styles['arrow']}>↕</span>
            </button>
          </div> */}

          {/* 订单信息头部 */}
          <div className={styles['bidding-header']}>
            <div className={styles['bidding-title']}>
              <p className={styles['bidding-title1']}>Appliance Repair/Air Conditioning Repair</p>
              <p className={styles['bidding-title-text']}>Order Number: 14785236987463157245</p>
            </div>
            <div className={styles['bidding-total']}>
              Total {biddingData.length} Orders
            </div>
          </div>

          {/* 竞价列表表格 */}
          <div className={styles['bidding-table']}>
            <table>
              <thead>
                <tr>
                  <th>Number</th>
                  <th>Townloop ID</th>
                  <th>Pricing Method</th>
                  <th>Price</th>
                  <th>Creation Time</th>
                  {/* <th>Distance</th> */}
                  <th>Operations</th>
                </tr>
              </thead>
              <tbody>
                {biddingData
                  .slice((biddingPagination.current - 1) * biddingPagination.pageSize, biddingPagination.current * biddingPagination.pageSize)
                  .map((item, index) => (
                    <tr key={item.carpool_order_bidding_id}>
                      <td>{(biddingPagination.current - 1) * biddingPagination.pageSize + index + 1}</td>
                      <td>{item.carpool_order_bidding_id}</td>
                      <td>{item.pricing_method == 0 ? 'Bidding' : 'Fixed Price'}</td>
                      <td className={styles['price-cell']}>${item.bidding_price}</td>
                      <td>{item.created_time}</td>
                      {/* <td>{item.distance}</td> */}
                      <td>
                        <button
                          className={styles['pay-btn']}
                          onClick={() => handlePayClick(item)}
                        >
                          Pay
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* 分页 */}
          <div className={styles['bidding-pagination']}>
            <Pagination
              current={biddingPagination.current}
              pageSize={biddingPagination.pageSize}
              total={biddingData.length}
              onChange={handleBiddingPaginationChange}
              showSizeChanger={false}
              showQuickJumper
              showTotal={(total, range) => `${t('common.Total')} ${total} Products`}
            />
          </div>
        </div>
      </Modal>

      {/* 发布人支付车费弹窗 */}
      <Membership
        open={membershipModalOpen}
        onCancel={handleMembershipCancel}
        onConfirm={handleMembershipConfirm}
        membershipType={0}
        isCarpoolService={true}
        carpoolBiddingPrice={selectedBiddingItem?.bidding_price}
        carpoolOrderId={selectedBiddingItem?.carpool_order_id}
        carpoolBiddingId={selectedBiddingItem?.carpool_order_bidding_id}
      />
      {/* 发布人支付车费弹窗 */}

      {/* 司机有偿取消弹窗 */}
      <Membership
        open={driverCancelsPaymentModalOpen}
        onCancel={handleDriverCancelsPaymentCancel}
        onConfirm={handleDriverCancelsPaymentConfirm}
        membershipType={0}
        isCarpoolService={false}
        isDriverCancellation={true}
        carpoolBiddingPrice={selectedDriverCancelsPaymentItem?.budget_price}
        carpoolOrderId={selectedDriverCancelsPaymentItem?.carpool_order_id || selectedDriverCancelsPaymentItem?.delivery_order_id}
      />
      {/* 司机有偿取消弹窗 */}


      {/* 会员支付成功弹窗 */}
      <Modal
        open={showPaySuccess}
        onCancel={closePaySuccess}
        footer={null}
        width={800}
        centered
        className={styles['pay-success-modal']}
      >
        <div className={styles['pay-success-content']}>
          <div className={styles['success-icon']}>
            <CheckOutlined />
          </div>
          <div className={styles['success-title']}>Pay Success</div>
        </div>
      </Modal>
      {/* 会员支付成功弹窗 */}

      {/* 编辑发布人顺风车帖子弹窗 */}
      <Modal
        open={showPublishModal}
        onCancel={() => setShowPublishModal(false)}
        footer={null}
        width={1200}
        centered
        maskClosable={false}
        className={styles['publish-modal']}

      >
        <div className={styles['publish-title']}>Order Release</div>
        <div className={styles['publish-body']}>

          {type === 'ride' ? (
            <div className={styles['form-columns']}>
              {/* 左列 */}
              <div className={styles['left-column']}>
                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Departure Date:</label>
                  {/* format('YYYY-MM-DD HH:mm:ss'),  //YYYY-MM-DD HH:mm:ss    MM-DD-YYYY HH:mm:ss */}
                  <DatePicker
                    showTime
                    format="MM-DD-YYYY HH:mm:ss"
                    className={styles['input']}
                    value={publishForm.departure_date}
                    placeholder="Departure Date / Time"
                    onChange={(v) => handlePublishChange('departure_date', v)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Acceptable Advance / Delay:</label>
                  <Input
                    type="number"
                    className={styles['input']}
                    placeholder="Acceptable Advance / Delay"
                    value={publishForm.acceptable_advance_delay}
                    onChange={(e) => handlePublishChange('acceptable_advance_delay', e.target.value)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Starting Point:</label>
                  <div className={styles['nested-inputs']}>
                    <Select
                      className={styles['input']}
                      placeholder="State"
                      value={publishForm.starting_point_state}
                      onChange={(v) => handlePublishChange('starting_point_state', v)}
                    >
                      {
                        StateList.map((item, index) => (
                          <Option value={item.value} key={index}>{item.label}</Option>
                        ))
                      }

                    </Select>
                    <Input
                      className={styles['input']}
                      placeholder="City"
                      value={publishForm.starting_point_city}
                      onChange={(e) => handlePublishChange('starting_point_city', e.target.value)}
                    />
                    <Input
                      className={styles['input']}
                      placeholder="Address"
                      value={publishForm.starting_point_address}
                      onChange={(e) => handlePublishChange('starting_point_address', e.target.value)}
                    />
                  </div>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Seats Needed:</label>
                  <Select
                    className={styles['input']}
                    placeholder="Seats Needed"
                    value={publishForm.seats_needed}
                    onChange={(v) => handlePublishChange('seats_needed', v)}

                  >
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>

                  </Select>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Fixed Price:</label>
                  <Input
                    type='number'
                    className={styles['input']}
                    placeholder="E.G., $100"
                    value={publishForm.final_price}
                    onChange={(e) => handlePublishChange('fixed_price', e.target.value)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>Service Requirements:</label>
                  <Input
                    className={styles['input']}
                    placeholder="Please Fill In"
                    value={publishForm.service_requirements}
                    onChange={(e) => handlePublishChange('service_requirements', e.target.value)}
                  />
                </div>
              </div>

              {/* 右列 */}
              <div className={styles['right-column']}>


                <div className={styles['form-group']} style={{ marginTop: '82px' }}>
                  <label className={styles['form-label']}>*Stopovers:</label>
                  <Select
                    className={styles['input']}
                    placeholder="Stopovers"
                    value={publishForm.stopovers}
                    onChange={(v) => handlePublishChange('stopovers', v)}
                  >
                    <Option value="0">0</Option>
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>

                  </Select>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Destination:</label>
                  <div className={styles['nested-inputs']}>
                    <Select
                      className={styles['input']}
                      placeholder="State"
                      value={publishForm.destination_point_state}
                      onChange={(v) => handlePublishChange('destination_point_state', v)}
                    >
                      {
                        StateList.map((item, index) => (
                          <Option value={item.value} key={index}>{item.label}</Option>
                        ))
                      }
                    </Select>
                    <Input
                      className={styles['input']}
                      placeholder="City"
                      value={publishForm.destination_point_city}
                      onChange={(e) => handlePublishChange('destination_point_city', e.target.value)}
                    />
                    <Input
                      className={styles['input']}
                      placeholder="Address"
                      value={publishForm.destination_point_address}
                      onChange={(e) => handlePublishChange('destination_point_address', e.target.value)}
                    />
                  </div>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Luggage:</label>
                  <Select
                    className={styles['input']}
                    placeholder="Luggage:"
                    value={publishForm.has_luggage}
                    onChange={(v) => handlePublishChange('has_luggage', v)}
                  >
                    <Option value={true}>yes</Option>
                    <Option value={false}>no</Option>

                  </Select>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Budget:</label>
                  <Input
                    type='number'
                    className={styles['input']}
                    placeholder="E.G., $200"
                    value={publishForm.budget_price}
                    onChange={(e) => handlePublishChange('bidding_price', e.target.value)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>Notes:</label>
                  <Input
                    className={styles['input']}
                    placeholder="Notes"
                    value={publishForm.notes}
                    onChange={(e) => handlePublishChange('notes', e.target.value)}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={styles['form-columns']}>
              {/* 左列 */}
              <div className={styles['left-column']}>
                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Pickup Location:</label>
                  <div className={styles['nested-inputs']}>
                    <Select
                      className={styles['input']}
                      placeholder="State"
                      value={publishForm.starting_point_state}
                      onChange={(v) => handlePublishChange('starting_point_state', v)}
                    >
                      {
                        StateList.map((item, index) => (
                          <Option value={item.value} key={index}>{item.label}</Option>
                        ))
                      }
                    </Select>
                    <Input
                      className={styles['input']}
                      placeholder="City"
                      value={publishForm.starting_point_city}
                      onChange={(e) => handlePublishChange('starting_point_city', e.target.value)}
                    />
                    <Input
                      className={styles['input']}
                      placeholder="Address"
                      value={publishForm.starting_point_address}
                      onChange={(e) => handlePublishChange('starting_point_address', e.target.value)}
                    />
                  </div>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Pickup Time:</label>
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm A"
                    className={styles['input']}
                    value={publishForm.pickup_time}
                    placeholder="2025-10-16 10:00 AM"
                    onChange={(v) => handlePublishChange('pickup_time', v)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Item Description:</label>
                  <Input
                    className={styles['input']}
                    placeholder="E.G. Cake"
                    value={publishForm.item_description}
                    onChange={(e) => handlePublishChange('item_description', e.target.value)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Package Size:</label>
                  <Select
                    className={styles['input']}
                    placeholder="Small (≤ 12 × 8 × 4 In)"
                    value={publishForm.package_size}
                    onChange={(v) => handlePublishChange('package_size', v)}
                  >
                    <Option value="Small (≤ 12 × 8 × 4 In)">Small (≤ 12 × 8 × 4 In)</Option>
                    <Option value="Medium (≤ 20 × 16 × 12 In)">Medium (≤ 20 × 16 × 12 In)</Option>
                    <Option value="Large (≤ 32 × 24 × 20 In)">Large (≤ 32 × 24 × 20 In)</Option>
                    <Option value="Extra Large (> 32 × 24 × 20 In)">Extra Large (&gt; 32 × 24 × 20 In)</Option>
                  </Select>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Fixed Price:</label>
                  <Input
                    type='number'
                    className={styles['input']}
                    placeholder="E.G., $100"
                    value={publishForm.final_price}
                    onChange={(e) => handlePublishChange('fixed_price', e.target.value)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>Notes:</label>
                  <Input
                    className={styles['input']}
                    placeholder="Notes"
                    value={publishForm.notes}
                    onChange={(e) => handlePublishChange('notes', e.target.value)}
                  />
                </div>
              </div>

              {/* 右列 */}
              <div className={styles['right-column']}>
                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Drop-Off Location:</label>
                  <div className={styles['nested-inputs']}>
                    <Select
                      className={styles['input']}
                      placeholder="State"
                      value={publishForm.destination_point_state}
                      onChange={(v) => handlePublishChange('destination_point_state', v)}
                    >
                      {
                        StateList.map((item, index) => (
                          <Option value={item.value} key={index}>{item.label}</Option>
                        ))
                      }
                    </Select>
                    <Input
                      className={styles['input']}
                      placeholder="City"
                      value={publishForm.destination_point_city}
                      onChange={(e) => handlePublishChange('destination_point_city', e.target.value)}
                    />
                    <Input
                      className={styles['input']}
                      placeholder="Address"
                      value={publishForm.destination_point_address}
                      onChange={(e) => handlePublishChange('destination_point_address', e.target.value)}
                    />
                  </div>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Expected Delivery Time:</label>
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm A"
                    className={styles['input']}
                    value={publishForm.expected_delivery_time}
                    placeholder="2025-10-16 2:00 PM"
                    onChange={(v) => handlePublishChange('expected_delivery_time', v)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Quantity:</label>
                  <Input
                    type="number"
                    className={styles['input']}
                    placeholder="1"
                    value={publishForm.quantity}
                    onChange={(e) => handlePublishChange('quantity', e.target.value)}
                  />
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Package Weight:</label>
                  <Select
                    className={styles['input']}
                    placeholder="Under 2.2 Lbs"
                    value={publishForm.package_weight}
                    onChange={(v) => handlePublishChange('package_weight', v)}
                  >
                    <Option value="Under 2.2 lbs">Under 2.2 lbs</Option>
                    <Option value="2.2-11 lbs">2.2-11 lbs</Option>
                    <Option value="11-22 lbs">11-22 lbs</Option>
                    <Option value="22-44 lbs">22-44 lbs</Option>
                    <Option value="Over 44+ lbs">Over 44+ lbs</Option>
                  </Select>
                </div>

                <div className={styles['form-group']}>
                  <label className={styles['form-label']}>*Bidding:</label>
                  <Input
                    type='number'
                    className={styles['input']}
                    placeholder="E.G., $200"
                    value={publishForm.budget_price}
                    onChange={(e) => handlePublishChange('bidding_price', e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}


          <div className={styles['publish-actions']}>
            <Button className={styles['cancel-btn']} onClick={cancelSubmit}>Cancel</Button>
            <Button className={styles['post-ride-btn']} type="primary" onClick={type === 'ride' ? submitPostRide : submitPostDelivery}>Confirm</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default YourTownloopOrdersList; 